export default __webpack_public_path__ + "static/media/gallery_11.a99692fd.jpg";